import React from "react"
import IconsColor from "../../util/iconsColor"
import styles from "../../asset/styles/agents/agencyWizardStepper.module.scss"

export type WizardStepConfig = {
    id: number
    label: string
}

type AgencyWizardStepperProps = {
    steps: WizardStepConfig[]
    currentStep: number
    completedSteps: Set<number>
    onStepClick: (step: number) => void
}

const AgencyWizardStepper: React.FC<AgencyWizardStepperProps> = ({
    steps,
    currentStep,
    completedSteps,
    onStepClick,
}) => {
    return (
        <div className={styles.stepper}>
            {steps.map((step, index) => {
                const isCompleted = completedSteps.has(step.id)
                const isActive = currentStep === step.id
                const isLast = index === steps.length - 1

                return (
                    <React.Fragment key={step.id}>
                        <button
                            type="button"
                            className={styles.stepButton}
                            onClick={() => onStepClick(step.id)}
                            aria-current={isActive ? "step" : undefined}
                        >
                            <span
                                className={[
                                    styles.stepCircle,
                                    isCompleted ? styles.stepCircleCompleted : "",
                                    isActive ? styles.stepCircleActive : "",
                                    !isCompleted && !isActive ? styles.stepCirclePending : "",
                                ]
                                    .filter(Boolean)
                                    .join(" ")}
                            >
                                {isCompleted ? (
                                    <IconsColor
                                        iconName="checkIcon"
                                        width="14"
                                        height="14"
                                        fillColor="none"
                                        strokeColor="#16a34a"
                                    />
                                ) : (
                                    step.id
                                )}
                            </span>
                            <span
                                className={[
                                    styles.stepLabel,
                                    isActive ? styles.stepLabelActive : "",
                                    isCompleted ? styles.stepLabelCompleted : "",
                                ]
                                    .filter(Boolean)
                                    .join(" ")}
                            >
                                {step.label}
                            </span>
                        </button>
                        {!isLast && (
                            <span
                                className={[
                                    styles.stepConnector,
                                    isCompleted ? styles.stepConnectorCompleted : "",
                                ]
                                    .filter(Boolean)
                                    .join(" ")}
                            />
                        )}
                    </React.Fragment>
                )
            })}
        </div>
    )
}

export default AgencyWizardStepper
